export default __webpack_public_path__ + "static/united-kingdom-b9a2ba74e5f8a55977e74f6455f83c2f.png";